
<section class="py-16 w-full">
  <!-- Header Info -->
  <div class="w-full flex flex flex-wrap justify-between items-center mb-24 text-am-black-75">
    <div class="flex flex-col gap-1 mb-6 md:mb-0">
      <p class="text-am-black-75">Industry:</p>
      <p class="text-lg text-am-black !font-semibold">B2B Software As A Service</p>
    </div>

    <div class="flex flex-col gap-1 mb-6 md:mb-0">
      <p class="text-am-black-75">Founder & CEO:</p>
      <a href="https://no.linkedin.com/in/kiran-ramaiah-006" class="flex gap-2 items-center p-2 border-2 border-am-black-45 rounded-lg group hover:border-am-blue transition duration-300 ease-in-out">
        <img
          src="/kiran_about_header.jpg"
          alt="The founder of AddMeetings"
          class="w-7 h-7 rounded-full object-cover"
        />
        <p class="text-lg text-am-black !font-semibold group-hover:text-am-blue transition duration-300 ease-in-out">Kiran Ramaiah</p>
      </a>
    </div>

    <div class="flex flex-col gap-1 mb-6 md:mb-0">
      <p class="text-am-black-75">Location:</p>
      <p class="text-lg text-am-black !font-semibold">Norway</p>
    </div>
  </div>

  <!-- Story Section -->
  <div class="flex flex-col w-full gap-16">
    <div 
      class="w-full pt-8 border-t border-am-white-60 flex flex-col sm:flex-row gap-8 items-start justify-between md:px-16 lg:px-24 xl:px-32"
    >
      <h2 class="text-4xl md:text-5xl font-bold">
        <span class="text-am-white-60">Our</span>
        <span class="text-am-black">Story</span>
      </h2>
      
      <p class="text-am-black !font-semibold leading-relaxed sm:max-w-sm text-lg">
        AddMeetings was founded in 2024 by Kiran Ramaiah, a second-time startup founder originally from India and now based in Oslo, Norway. After years of dealing with irrelevant meeting requests and wasted time in cold outreach, Kiran set out to build a smarter way for B2B professionals to connect, one that replaces noise with meaningful, qualified conversations.
      </p>
    </div>
 
    
    <div 
      class="w-full pt-8 border-t border-am-white-60 flex flex-col sm:flex-row gap-8 items-start justify-between md:px-16 lg:px-24 xl:px-32"
    >
      <h2 class="text-4xl md:text-5xl font-bold">
        <span class="text-am-white-60">Our</span>
        <span class="text-am-black">Progress</span>
      </h2>
      
      <p class="text-am-black !font-semibold leading-relaxed sm:max-w-sm text-lg">
        AddMeetings is live and growing steadily, with hundreds of B2B professionals already using it to qualify meetings and cut through outreach clutter. We’re continuously improving the platform with regular updates, expanding integrations beyond Google Calendar, and building new features like Outlook support, browser extensions, and AI-powered meeting analytics.
      </p>
    </div>
    
  </div>
</section>